import styled from 'styled-components'

const FieldSet = styled.fieldset`
  min-height: 48px;
  counter-increment: fieldset;
`

FieldSet.Legend = styled.legend`
  position: relative;
  padding-left: 64px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-bottom: 26px;
  font-weight: 300;
  font-size: 20px;
  line-height: 1.2;
  color: var(--color-main);

  &::before {
    content: counter(fieldset);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    border: 1px solid var(--color-border);
    border-radius: 50%;
    font-weight: bold;
    font-size: 14px;
    line-height: 1.2;
    color: var(--color-main);
  }
`

export default FieldSet
